import DashboardLayout from "../../lib/components/layouts/dashboard";
import { AppContext } from "lib/contexts/app-context";
import { useContext, useEffect, useState } from "react";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { isPatientUser } from "lib/utils/util";
import usePatients from "lib/hooks/usePatients";
import SimpleCard from "lib/components/common/simple-card";

const PatientNotesPage = () => {
  const { appState } = useContext(AppContext);
  const { getPatientDetails } = usePatients();

  const patientId = appState?.user_id;

  const [notes, setNotes] = useState<string>("");

  const BreadcrumbItems: BreadcrumbItem[] = [
    {
      label: "Dashboard",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.Dashboard
        : PAGE_ROUTES.PRACTITIONER.Dashboard,
    },
    {
      label: "Notes",
      path: PAGE_ROUTES.PATIENT.Notes,
    },
  ];

  useEffect(() => {
    if (!patientId) return;

    getPatientDetails(patientId, (res: any) => {
      setNotes(res?.notes || "");
    });
  }, [patientId]);

  return (
    <DashboardLayout breadcrumbItems={BreadcrumbItems}>
      <SimpleCard title="Your Notes" className="shadow-sm p-4">
        {notes ? (
          <div
            style={{ whiteSpace: "pre-wrap" }}
            dangerouslySetInnerHTML={{ __html: notes }}
          />
        ) : (
          <p>No notes available.</p>
        )}
      </SimpleCard>
    </DashboardLayout>
  );
};

export default PatientNotesPage;
